
import Vue from 'vue'
import SignInUpCommon from './SignInUpCommon.vue'

export default Vue.extend({
  name: 'Sign-in-up',
  components: {
    SignInUpCommon,
  },
  data: () => ({}),
})
